export default {
  type: 'service_authorization',
  config: {
    relationships: {
      "case": {
        type: 'case'
      },
      fee_schedule_program: {
        type: 'fee_schedule_program'
      },
      insurance: {
        type: 'insurance'
      },
      person: {
        type: 'person'
      },
      requester: {
        type: 'employee'
      },
      reviewer: {
        type: 'employee'
      },
      service_authorization_denial_reason: {
        type: 'service_authorization_denial_reason'
      },
      zcodes: {
        type: 'zcode'
      }
    }
  }
};
//# sourceMappingURL=service_authorization.js.map